import { h } from "preact";
import { useState, useEffect, useRef, useCallback } from "preact/hooks";
import { Autocomplete } from "@mui/material";
import { TextField, } from "@mui/material";

import { LocationClient, SearchPlaceIndexForTextCommand, SearchPlaceIndexForSuggestionsCommand } from "@aws-sdk/client-location";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";

const useDebouncedCallback = (func, wait) => {
    const timeout = useRef();

    return useCallback(
        (...args) => {
            const later = () => {
                clearTimeout(timeout.current);
                func(...args);
            };

            clearTimeout(timeout.current);
            timeout.current = setTimeout(later, wait);
        },
        [func, wait]
    );
};

export default function DebouncedAWSLocationInput({ resultsCallback, setUpperState, upperState, mode }) {
    //mode ADR -> adresse de bien

    const [searchQuery, setSearchQuery] = useState("");
    const [searchQueryHistory, setSearchQueryHistory] = useState("");
    // const [creds, setCreds] = useState(undefined);
    //  const [client, setClient] = useState(undefined);
    const creds = new fromCognitoIdentityPool({
        clientConfig: { region: 'eu-west-1' }, // Configure the underlying CognitoIdentityClient.
        identityPoolId: 'eu-west-1:c132366c-3b60-4aae-a2ca-df624f4c6e5d',

    })
    const client = new LocationClient({
        region: 'eu-west-1',
        credentials: creds,

    });


    useEffect(() => {

    }, [creds, client]);



    const onSearch = useDebouncedCallback(() => {

        if (searchQuery === "") { return }
        if (mode == "SE" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };
        if (mode == "ADR" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };
        if (mode == "AMB" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };
        if (mode == "AMB2" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };
        if (mode == "USR" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };
        if (mode == "NTR" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };
        if (mode == "PRX" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };
        if (searchQuery.length > 0 && searchQuery !== searchQueryHistory) {
            // Hit the API
            //const response = searchQuery.toUpperCase();

            const command = new SearchPlaceIndexForTextCommand({ Text: searchQuery, MaxResults: 10, FilterCountries: ["FRA"], IndexName: "here.ds" });
            //  const command = new SearchPlaceIndexForTextCommand({ Text: searchQuery, MaxResults: 10, FilterCountries: ["FRA"], IndexName: "explore.place" });
            client.send(command).then((res) => {

                setSearchQueryHistory(searchQuery);
                setOptions(res.Results.filter((rec) => { return rec.Place.Street !== undefined }));
            }).catch(err => console.log("err", err));

        }
    }, 500);

    useEffect(() => {
        onSearch();
    }, [searchQuery, onSearch]);
    const [options, setOptions] = useState([]);

    useEffect(() => {

    }, [options]);

    return (
        <div>
            <Autocomplete
                //id=
                filterOptions={(x) => x}
                // sx={{ width: "100%" }}
                sx={{ width: 300 }}
                autoComplete
                freeSolo
                options={options}
                getOptionLabel={(option) => (option.Place.AddressNumber ? option.Place.AddressNumber + ' ' : '') + (option.Place.Street ? option.Place.Street + ' ' : '') + ' ' + option.Place.Municipality} //+ ' ' + option.Place.PostalCode}
                onInputChange={(e) => setSearchQuery(e.target.value)}
                onChange={(event, newValue) => {
                    var plc = newValue.Place;
                    var lbl = `${plc.AddressNumber ? plc.AddressNumber : ""}, ${plc.Street ? plc.Street : ""}, ${plc.PostalCode ? plc.PostalCode : ""} ${plc.Municipality ? plc.Municipality : ""}`;
                    plc["Label"] = lbl;
                    resultsCallback(plc);
                }}
                clearText="Effacer"
                noOptionsText={searchQuery !== "" ? <em>Désolé, nous n'avons pas trouvé d'adresse</em> : ""}
                renderInput={(params) => (

                    <TextField
                        {...params}
                        id="query"
                        name="query"

                        fullWidth
                        placeholder="Adresse"
                        margin="dense"
                        size="small"
                        style="padding: 0px;"
                        value={searchQueryHistory}
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                    />


                )}
            />
        </div>
    );
}
